const searchFamilies = [
  {aliases:['armario refrigerado','armarios refrigerados','armario frigorifico','armarios frigorificos','frigorifico','frigorificos','refrigerador','refrigeradores'],types:['Armario refrigerado']},
  {aliases:['armario congelador','armarios congeladores','armario congelados','armarios congelados'],types:['Armario congelador']},
  {aliases:['mesa refrigerada','mesas refrigeradas','bajomostrador','bajomostradores'],types:['Mesa Refrigerada','Mesa Coctelera Refrigerada']},
  {aliases:['lavavajillas cupula','lavaplatos cupula','cupula','cupulas'],types:['Lavaplatos Cúpula']},
  {aliases:['lavavaso','lavavasos'],types:['Lavavasos industrial']},
  {aliases:['lavavajilla','lavavajillas','lavaplato','lavaplatos'],types:['Lavaplatos','Lavaplatos Cúpula']},
  {aliases:['arcon','arcones'],types:['Congelador horizontal']},
  {aliases:['congelador','congeladores','congelados','congelacion'],types:['Armario congelador','Congelador horizontal']},
  {aliases:['abatidor','abatidores'],types:['Abatidor de temperatura']},
  {aliases:['fregadero','fregaderos'],types:['Fregadero']},
  {aliases:['lavamanos'],types:['Lavamanos']},
  {aliases:['freidora','freidoras'],types:['Freidoras eléctricas']},
  {aliases:['plancha','planchas'],types:['Planchas eléctricas','Planchas a gas']},
  {aliases:['horno','hornos'],types:['Hornos de Pizza','Hornos de convección']},
  {aliases:['envasadora','envasadoras'],types:['Envasadoras al vacío']},
  {aliases:['botellero','botelleros'],types:['Botellero refrigerado']},
  {aliases:['vitrina','vitrinas'],types:['Vitrinas refrigeradas']},
  {aliases:['panini','paninis','sandwichera','sandwicheras'],types:['Sandwicheras y paninis']},
  {aliases:['cortadora','cortadoras'],types:['Cortadoras de fiambres']},
  {aliases:['amasadora','amasadoras'],types:['Amasadoras']},
  {aliases:['batidora','batidoras'],types:['Batidoras planetarias']},
  {aliases:['estanteria','estanterias'],types:['Estantería','Estantería Perfil Ranurado','Estantería de Pie Lineal','Estante de Sobremesa']},
];
const queryStopWords=new Set(['de','del','para','y','el','la','los','las','un','una']);
const familyDescriptors=new Set(['industrial','industriales','profesional','profesionales','hosteleria']);
export function cleanSearchQuery(value){
  const text=value.trim();
  if(!text || /(?:title|product_type|variants\.sku|vendor|id):/.test(text))return text;
  const words=(text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().match(/[a-z0-9-]+/g)||[]).filter(word=>!queryStopWords.has(word));
  let selected=null;
  let matchStart=-1;
  let matchLength=0;
  for(const family of searchFamilies){
    for(const alias of family.aliases){
      const parts=alias.split(' ');
      for(let i=0;i<=words.length-parts.length;i++){
        if(parts.length>matchLength && parts.every((part,j)=>words[i+j]===part)){
          selected=family;matchStart=i;matchLength=parts.length;
        }
      }
    }
  }
  const remaining=words.filter((word,i)=>!(i>=matchStart && i<matchStart+matchLength) && !(selected && familyDescriptors.has(word)));
  const clauses=remaining.map(word=>'(title:'+word+'* OR vendor:'+word+'* OR variants.sku:'+word+'*)');
  if(selected){
    const types=selected.types.map(type=>'product_type:'+JSON.stringify(type));
    clauses.unshift(types.length===1?types[0]:'('+types.join(' OR ')+')');
  }
  return clauses.join(' AND ')||text;
}
export function cleanSearchUrl(value){
  const url=new URL(Theme.routes.search_url,location.origin);
  url.searchParams.set('q',cleanSearchQuery(value));
  url.searchParams.set('gb_terms',value.trim());
  url.searchParams.set('type','product');
  return url;
}
document.addEventListener('submit',event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||form.getAttribute('role')!=='search')return;
  const input=form.querySelector('input[name="q"]');
  if(!input)return;
  event.preventDefault();
  location.href=cleanSearchUrl(input.value).toString();
},true);
const current=new URL(location.href);
const original=current.searchParams.get('gb_terms');
if(original!==null){
  document.querySelectorAll('input[name="q"]').forEach(input=>{input.value=original;});
  const query=current.searchParams.get('q');
  if(query)document.title=document.title.replace(query,original);
  if(query)document.querySelectorAll('.search-results__no-results p,[role="status"]').forEach(el=>{
    if(el.textContent.includes(query))el.textContent=el.textContent.replace(query,original);
  });
}

